export default {
    pay_getPayInfo: "client/order/pay",
    //生成钱包支付信息
    generateWalletPayInfo: "client/wallet/pay/orderWalletPay",
    //发送钱包限额短信
    sendWalletCreditSms: "client/pc/wallet/sendLimitationOrderSms",
    //校验钱包限额验证码
    validateWalletCreditSms:
        "client/pc/wallet/checkLimitationOrderVerificationCode",
    //查询支付信息是否修改
    queryPaymentPriceIsModif: "client/order/checkIsOrderAlter",
};
